"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ChartNetwork: function() {
        return ChartNetwork;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const ChartNetwork = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M6 3C6 1.89543 6.89543 1 8 1C9.10457 1 10 1.89543 10 3C10 3.40731 9.87824 3.78618 9.66914 4.10221L11.703 8.16987C12.1166 8.05908 12.5514 8 13 8C14.0191 8 14.967 8.30488 15.7574 8.8284L19.0677 5.51804C19.0236 5.35282 19 5.17916 19 5C19 3.89543 19.8954 3 21 3C22.1046 3 23 3.89543 23 5C23 6.10457 22.1046 7 21 7C20.8208 7 20.6472 6.97644 20.482 6.93226L17.1716 10.2426C17.6951 11.033 18 11.9809 18 13C18 14.044 17.68 15.0133 17.1328 15.8152L19.6987 19.0226C19.7969 19.0077 19.8976 19 20 19C21.1046 19 22 19.8954 22 21C22 22.1046 21.1046 23 20 23C18.8954 23 18 22.1046 18 21C18 20.743 18.0485 20.4974 18.1367 20.2717L15.6912 17.2147C14.9142 17.7118 13.9908 18 13 18C10.581 18 8.56329 16.2822 8.10002 14H4.73244C4.38663 14.5978 3.74028 15 3 15C1.89543 15 1 14.1046 1 13C1 11.8954 1.89543 11 3 11C3.74028 11 4.38663 11.4022 4.73244 12H8.10002C8.34031 10.8162 8.99881 9.78434 9.91458 9.06524L7.8802 4.99647C6.83141 4.93451 6 4.06435 6 3ZM13 10C11.3431 10 10 11.3431 10 13C10 14.6569 11.3431 16 13 16C14.6569 16 16 14.6569 16 13C16 11.3431 14.6569 10 13 10Z",
        fill: "currentColor"
    })
}), "ChartNetwork");
const _default = ChartNetwork;
